module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style8/message-alert-style8.component.scss
// module id = ./src/app/features/message-alert/message-alert-style8/message-alert-style8.component.scss
// module chunks = main